// extracted by mini-css-extract-plugin
module.exports = {"rsvpCell":"rsvpCell--6393c","rsvpCopy":"rsvpCopy--f5a41"};